const API_BASE = import.meta.env.REACT_APP_API_URL || '/api';

export const getGoogleOAuthUrl = () => `${API_BASE}/auth/google`;

export const redirectToGoogleOAuth = () => {
  window.location.href = getGoogleOAuthUrl();
};
